import AmexFooter from './AmexFooter';

export default AmexFooter;
